<template>
  <table class="table  table--noborder table-zebra">
    <thead class="table__head">
    <tr class="table__row">
      <th></th>
      <th></th>
      <th></th>
      <th class="table__cell  table__hcell" style="width: 10%;">
        <v-select
            :options="statuses"
            :reduce="option=>option.stat"
            label="title"
            :placeholder="getTranslation('selectFromList')"
            v-model="status"
        />
      </th>
    </tr>
    <tr class="table__row">
      <th class="table__cell  table__hcell" style="width: 30%;">{{ getTranslation('namingNPA') }} - {{ npaList.length }}
      </th>
      <th class="table__cell  table__hcell" style="width: 25%;">{{ getTranslation('activeQuestionCount') }} <span
          class="badge badge--accent">{{ totalActiveQuestionCount }}</span></th>
      <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('type') }}</th>
      <th class="table__cell  table__hcell" style="width: 10%;">{{ getTranslation('status') }}</th>
    </tr>
    </thead>
    <tbody class="table__body">
    <tr class="table__row" v-for="item in npaList" v-bind:key="item.id">
      <td class="table__cell">
        <router-link :to="{name:'api.testing.get',params:{id:item.id}}">{{ item.title }}</router-link>
      </td>

      <td class="table__cell">
        <span :class="{'text--danger':item.activeQuestionCount < 1}">{{ item.activeQuestionCount }}</span>
      </td>

      <td class="table__cell">{{ item.type.title }}</td>

      <td class="table__cell">{{ item.statusTitle }}</td>

    </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'NpaList',
  props: {
    tests: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      npaList: [],
      status: true,
      statuses: [
        {
          stat: true,
          title: 'Активен',
        },
        {
          stat: false,
          title: 'Заблокирован',
        },
      ],
    };
  },
  watch: {
    'status'(val) {
      if (typeof val === 'boolean') {
        this.npaList = this.tests.filter(item => {
          return val === item.status;
        });
      } else
        this.npaList = this.tests;
    },

    'tests'(val) {
      if (val && Array.isArray(val))
        this.npaList = val.filter(item => {
          return true === item.status;
        });

    }
  },
  computed: {
    totalActiveQuestionCount() {
      let total = 0;
      for (let test of this.npaList) {
        total += test.activeQuestionCount;
      }
      return total;
    }
  },
  created() {
    this.npaList = this.tests.filter(item => {
      return this.status === item.status;
    });
  },


};
</script>

<style scoped>

</style>
